import { ReactNode } from "react";
import styled from "styled-components";

type BadgeVariant = "primary" | "secondary" | "terciary" | "success" | "warning" | "danger";

type BadgeProps = {
    variant?: BadgeVariant;
    small: boolean;
    children: ReactNode;
};

const BadgeContainer = styled.span<{ variant: BadgeVariant; small: boolean }>`
    background: ${({ theme, variant }) => theme.color[variant].background};
    color: ${({ theme, variant }) => theme.color[variant].foreground};
    padding: 0.25rem;
    border-radius: 0.5rem;
    ${({ small }) => small ? `font-size: 0.85rem;` : ""}
`;

export const Badge = ({ children, small = false, variant = "primary"}: BadgeProps) => {
    return (
        <BadgeContainer variant={variant} small={small}>
            {children}
        </BadgeContainer>
    );
};
